import React from "react";
import { Link } from "react-router-dom";
import Reveal from "./reveal";

/**
 * General purpose card. With `to` it becomes a link card (hover lift + "Explore →").
 * Props: tag, icon, emoji, title, text, to, cta
 */
export default function InfoCard({ tag, icon, emoji, title, text, to, cta = "Explore", delay = 0, children }) {
  const body = (
    <>
      {emoji && <span className="market-flag">{emoji}</span>}
      {icon && <div className="card-icon">{icon}</div>}
      {tag && <span className="tag">{tag}</span>}
      <h3>{title}</h3>
      {text && <p>{text}</p>}
      {children}
      {to && <span className="go">{cta}</span>}
    </>
  );

  if (to) {
    return (
      <Reveal delay={delay}>
        <Link to={to} className="card">{body}</Link>
      </Reveal>
    );
  }
  return <Reveal className="card card--hover" delay={delay}>{body}</Reveal>;
}
